export default __webpack_public_path__ + "static/media/avatar.7d06b93c.png";